import { StyleSheet } from 'react-native';
import {
  heightPercentageToDP as hp,
  widthPercentageToDP as wp,
} from 'react-native-responsive-screen';

export const Chip_Styles = StyleSheet.create({
  buttonDelete: {
    cursor: 'pointer',
    backgroundColor: '#eb4129',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 12,
    height: hp(6.8),
    width: '50%',
    alignSelf: 'center',
    marginTop: hp(2.5),
  },
  buttonAdd: {
    cursor: 'pointer',
    backgroundColor: '#FFC451',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 12,
    height: hp(6.8),
    width: '50%',
    alignSelf: 'center',
    marginTop: hp(2.5),
  },
  // V3: Clean gray background with subtle border
  Chip: {
    marginHorizontal: hp(0),
    backgroundColor: '#F5F5F5',
    justifyContent: 'center',
    flexDirection: 'row',
    flex: 1,
    borderRadius: 20,
    borderColor: '#E5E5E5',
    borderWidth: 1,
    minHeight: 34,
  },
  // V3: Solid gold fill when selected
  ChipSelected: {
    marginHorizontal: hp(0),
    backgroundColor: '#FFC451',
    justifyContent: 'center',
    flexDirection: 'row',
    flex: 1,
    borderRadius: 20,
    borderColor: '#FFC451',
    borderWidth: 1,
    minHeight: 34,
  },
  ChipAdd: {
    marginHorizontal: hp(0),
    borderRadius: 20,
    backgroundColor: '#F5F5F5',
    justifyContent: 'center',
    flex: 1,
    borderColor: '#E5E5E5',
    borderWidth: 1,
    minHeight: 34,
    paddingHorizontal: 12,
  },
  ChipText: {
    marginHorizontal: hp(1.5),
    alignSelf: 'center',
  },
  ChipDeleteText: {
    marginRight: hp(1),
    borderRadius: 100,
  },
});

export const Web_Chip_Styles = StyleSheet.create({
  buttonDelete: {
    cursor: 'pointer',
    backgroundColor: '#eb4129',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 12,
    height: hp(6.8),
    width: '50%',
    alignSelf: 'center',
    marginTop: hp(2.5),
  },
  buttonAdd: {
    cursor: 'pointer',
    backgroundColor: '#FFC451',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 12,
    height: hp(6.8),
    width: '50%',
    alignSelf: 'center',
    marginTop: hp(2.5),
  },
  // V3: Clean gray background with subtle border
  Chip: {
    cursor: 'pointer',
    marginHorizontal: hp(0),
    backgroundColor: '#F5F5F5',
    justifyContent: 'center',
    flexDirection: 'row',
    flex: 1,
    borderRadius: 20,
    borderColor: '#E5E5E5',
    borderWidth: 1,
    minHeight: 34,
  },
  // V3: Solid gold fill when selected
  ChipSelected: {
    cursor: 'pointer',
    marginHorizontal: hp(0),
    backgroundColor: '#FFC451',
    justifyContent: 'center',
    flexDirection: 'row',
    flex: 1,
    borderRadius: 20,
    borderColor: '#FFC451',
    borderWidth: 1,
    minHeight: 34,
  },
  ChipAdd: {
    marginHorizontal: hp(0),
    borderRadius: 20,
    backgroundColor: '#F5F5F5',
    justifyContent: 'center',
    flex: 1,
    borderColor: '#E5E5E5',
    borderWidth: 1,
    minHeight: 34,
    paddingHorizontal: 12,
  },
  ChipText: {
    marginHorizontal: hp(1.5),
    alignSelf: 'center',
  },
  ChipDeleteText: {
    marginRight: hp(1),
    borderRadius: 20,
  },
});

// V3: AI chips - transparent background to match gold-tinted AI card
// Uses gold border to indicate AI-generated, with sparkle icon added in component
export const AI_Chip_Styles = StyleSheet.create({
  Chip: {
    marginHorizontal: hp(0),
    backgroundColor: 'rgba(255, 196, 81, 0.15)',
    justifyContent: 'center',
    flexDirection: 'row',
    flex: 1,
    borderRadius: 20,
    borderColor: 'rgba(255, 196, 81, 0.5)',
    borderWidth: 1,
    minHeight: 34,
  },
  ChipText: {
    marginHorizontal: hp(1.5),
    alignSelf: 'center',
  },
  // Icon container for sparkle
  ChipIcon: {
    marginLeft: hp(1.5),
    alignSelf: 'center',
  },
});
